import React from 'react'
import styles from './ToggleSwitch.module.scss'
import cx from 'classnames'

type ToggleSwitchProps = {
    property: string
    value: boolean
    label: string
    onChange: (property: string, value: boolean) => void
    classes?: string
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    property,
    value,
    label,
    onChange,
    classes,
}) => {
    return (
        <label className={cx(styles['zr-switch'], classes)}>
            <input
                type="checkbox"
                checked={value}
                onChange={(e) => onChange(property, e.target.checked)}
            />
            <div
                className={cx(styles['slider'], { [styles['checked']]: value })}
            >
                <div className={styles['knob']}></div>
            </div>
            <span className={styles['label-text']}>{label}</span>
        </label>
    )
}

export default ToggleSwitch
